import { action, observable } from 'mobx';
import i18n from 'i18next';
import UserOrderStoreModel from '../models/UserOrderStoreModel';
import api from '../api';

class UserStore {
  constructor(root) {
    this.root = root;
  }

  // 스토리지에 저장되는 주문 정보
  @observable userData = {
    phoneNumber: '', // 전화번호
    zipCode: '', // 우편번호
    sido: '', // 시/도
    sigungu: '', // 시/군/구
    dong: '', // 읍/면/동
    jibunAddress: '', // 지번 주소
    roadAddress: '', // 도로명 주소
    addressDetail: '', // 주소 상세
    latitude: 0, // 위도
    longitude: 0, // 경도
    isMember: false,
    isPointAdded: true,
    email: '',
    userCardNumber: '',
    deliveryType: '',
    zone: '',
    block: '',
    seat: '',
    orderList: [],
    seatToken: '', // 구장앱에서 delivery order link 로 접근 시 좌석 정보
    seatTokenDateTime: null, // seatToken 기록 시간
  };
  @observable userPoint = 0;

  /** 주문 매장 리스트 */
  @observable orderStores = [];

  /** 인코딩된 das 좌석정보 */
  @observable seatInfo = '';

  /** DAS user_id - sub 에 매칭되는 시스템 아이디 */
  @observable dasUserId = '';

  /** DAS 로그인을 통해 받은 토큰 */
  @observable dasToken = {};

  /** refresh_token 을 요청한 일자 / 시간 */
  @observable dasRequestDateTime = null;

  /** das 로그인을 요청한 현재의 url */
  @observable dasRequestUrl = null;

  /** das login 상태 */
  @observable isDasLogIn = false;

  /** 브라우저에 저장된 고객 입력 데이터 조회 */
  @action
  async setUserDataFromLocalStorage() {
    if (!this.userData.phoneNumber || !this.userData.email) {
      const storage = localStorage.getItem('storage');
      if (storage) this.userData = JSON.parse(storage);

      // das data setting
      this.setDasDataFromSessionStorage();
    }
  }

  @action
  setDasDataFromSessionStorage() {
    const dasStorage = sessionStorage.getItem('dasAuth');

    if (dasStorage) {
      const data = JSON.parse(dasStorage);
      this.dasToken = data.dasToken;
      this.dasRequestDateTime = data.dasRequestDateTime;
      this.dasRequestUrl = data.dasRequestUrl;
      this.dasUserId = data.dasUserId;
    }
  }

  // 주문 매장 리스트 조회
  @action
  async getUserOrderStores(encryptedId) {
    try {
      const response = await api.getOrderStoresByUser(encryptedId);

      this.orderStores = response.data.map(orderStore => new UserOrderStoreModel(orderStore));
    } catch (error) {
      this.root.commonStore.setError(i18n.t('ERROR_NOT_FOUND_ORDER_STORE'));
      throw error;
    }
  }

  @action
  setUserPoint(value) {
    this.userPoint = Number(value);
  }

  async removeExpirationOrderList() {
    this.userData.orderList = this.userData.orderList
      .filter(a => (new Date() - new Date(a.regDate).getTime()) / (1000 * 60 * 60 * 24) < 2)
      .sort(function (a, b) {
        return new Date(b.regDate).getTime() - new Date(a.regDate).getTime();
      });
  }

  saveUserData() {
    const storage = Object.assign({}, this.userData);
    localStorage.setItem('storage', JSON.stringify(storage));
  }

  /** das 로그인을 통해 받은 토큰 / 요청 시간 / 요청 url 저장 */
  saveDasData() {
    const dasStorage = {
      dasUserId: this.dasUserId, // DAS userinfo 를 통해 전달 받은 사용자 아이디
      dasToken: this.dasToken, // DAS 로그인을 통해 받은 토큰
      dasRequestDateTime: this.dasRequestDateTime, // refresh_token 을 요청한 일자 / 시간
      dasRequestUrl: this.dasRequestUrl, // das 로그인을 요청한 현재의 url
    };

    sessionStorage.setItem('dasAuth', JSON.stringify(dasStorage));
  }

  /** das 로그아웃 설정 */
  dasLogOut() {
    this.dasUserId = null;
    this.dasRequestDateTime = null;
    this.dasRequestUrl = null;
    this.dasToken = {};
    this.isDasLogIn = false;

    this.userData.email = '';
    this.userData.phoneNumber = '';
    this.userData.userCardNumber = '';
    this.saveUserData();

    sessionStorage.removeItem('dasAuth');
  }
}

export default UserStore;
